import { SubRouteAttributes, VisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy, ViewChild, TemplateRef, OnInit, ChangeDetectorRef } from "@angular/core";

import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
} from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TripAttributesExt } from "./dto/visit-report.interface";
import { TripService } from "./visit-report.service";
import { ImageCarouselComponent } from "./modal-image/modal-image.component";
import { MatBadgeModule } from "@angular/material/badge";
import { DateHourPipe } from "app/pipes/formated-date.pipe";
import { DomSanitizer } from "@angular/platform-browser";
import { ModalMapComponent } from "./modal-map/modal-map.component";
import { getCode } from "app/utils/method";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { ReplaySubject, takeUntil, take, Subject, Subscription } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportFileFormat, ExportRange } from "app/layout/export-overlay/tasks/core/export-task.enum";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { VisitReportExport } from "./exports/visit-report.export";
import { VISIT_REPORT_TITLE } from "./exports/visit-report.constants";
import { VisitDetailReportExport } from "./exports/visit-detail.export";
import { Router } from "@angular/router";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { FinanceFiltersComponent } from "app/modules/components/filters/finance-filters/finance-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { MapModalTypeEnum, MonitorDocumentTypeEnum } from "app/shared/components/map-modal/models/map-modal.enum";
import { DistanceCalculatorService } from 'app/services/distanceCalculatorService.service';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from "app/utils/date.helper";
import { SmartGridComponent, ColDef, GridConfig, PageChangedEvent, SortChangedEvent } from 'app/shared/components/smart-grid';
import { DatePipe } from '@angular/common';
import { ExcelIconCellRendererComponent } from './cell-renderers/excel-icon-cell-renderer.component';
import { MapIconCellRendererComponent } from './cell-renderers/map-icon-cell-renderer.component';
import { TripCellRendererComponent } from './cell-renderers/trip-cell-renderer.component';
import { RouteUserCellRendererComponent } from './cell-renderers/route-user-cell-renderer.component';
import { DateCellRendererComponent } from './cell-renderers/date-cell-renderer.component';
import { NumericCellRendererComponent } from './cell-renderers/numeric-cell-renderer.component';


@Component({
  selector: "app-visit-report",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatBadgeModule,
    DateHourPipe,
    NgxMatSelectSearchModule,
    FilterComponent,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    SmartGridComponent,
    DatePipe,
    ExcelIconCellRendererComponent,
    MapIconCellRendererComponent,
    TripCellRendererComponent,
    RouteUserCellRendererComponent,
    DateCellRendererComponent,
    NumericCellRendererComponent
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    VisitReportExport,
    VisitDetailReportExport,
    DatePipe
  ],
  templateUrl: "./visit-report.component.html",
  styleUrl: "./visit-report.component.scss",
})
export class VisitReportComponent implements OnInit, OnDestroy {
  getCode = getCode;

  // SmartGrid Data (using any because API returns grouped visit data with extra fields)
  data: any[] = [];
  columnDefs: ColDef<any>[] = [];
  gridConfig: GridConfig<any> = {} as GridConfig<any>;

  // Pagination
  totalItems = 0;
  pageSize = 50;
  pageIndex: number = 1;
  isLoading: boolean = false;

  // Search
  searchQuery: string = "";

  // Row Expansion
  selectedTrip: any | null = null;

  // Detail table for expanded row
  displayedColumnsDetail: string[] = [
    "geo",
    "visitImages",
    "bPartner",
    "visit",
    "documentNumber",
    "dateTimeStart",
    "duration",
    "location",
    "wasTheVisitOnSite",
    "validVisit",
  ];
  dataSourceDetail = new MatTableDataSource<VisitAttributes>([]);

  // Map to store detail data for each expanded row
  private expandedRowDetails = new Map<string, VisitAttributes[]>();

  // ViewChild references
  @ViewChild("rowDetailsTemplate", { static: false })
  rowDetailsTemplate!: TemplateRef<any>;

  @ViewChild(SmartGridComponent) smartGrid!: SmartGridComponent<any>;

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };
  subRouteList: SubRouteAttributes[] = [];


  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<SubRouteAttributes[]> = new FormControl<
    SubRouteAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<SubRouteAttributes[]> = new ReplaySubject<
    SubRouteAttributes[]
  >(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];


  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;
  
  form: FormGroup;

  //map
  isNew: boolean = true;

  loadFiltersData = false;

  sortActive = 'total';
  sortDirection: 'DESC' | 'ASC' = 'DESC';

  constructor(
    private tripService: TripService,
    private subRouteService: SubRouteService,
    private snackBar: MatSnackBar,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private exportService: ExportService,
    private visitReportExport: VisitReportExport,
    private visitDetailReportExport: VisitDetailReportExport,
    private readonly router: Router,
    private readonly searchService: SearchService,
    private fb: FormBuilder,
    private distanceCalculator: DistanceCalculatorService,
    private readonly cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      exp_start:[],
      exp_end: [],
      companyId: [],
      salesOfficeId: [],
      customerId:[],
      subRouteId: [],
      bankId: [],
      paymentConditionId: [],
    });
    this.matIconRegistry.addSvgIcon(
      "excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/mdi--file-excel.svg"
      )
    );
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  ngOnInit(): void {
    this.initializeColumnDefinitions();
    this.initializeGridConfig();
    this.onHandleSearch();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.findAllWithCount();
    }, 0);
  }

  private initializeColumnDefinitions(): void {
    this.columnDefs = [
      // Excel Download Icon
      {
        colId: "excel",
        headerName: "",
        width: 60,
        sortable: false,
        cellRenderer: ExcelIconCellRendererComponent,
        cellRendererParams: {
          onDownloadClick: (data: any) => this.downloadReportExcel(data),
        },
      },
      // Map Icon
      {
        colId: "map",
        headerName: "",
        width: 60,
        sortable: false,
        cellRenderer: MapIconCellRendererComponent,
        cellRendererParams: {
          onMapClick: (data: any) => this.openModal(data, "H"),
        },
      },
      // Trip column
      {
        field: "trip.id" as any,
        headerName: "Viaje",
        minWidth: 150,
        sortable: true,
        cellRenderer: TripCellRendererComponent,
        cellRendererParams: {
          onTripClick: (data: any) => this.goToTravel(data),
        },
      },
      // Route User column
      {
        field: "subRoute.model" as any,
        headerName: "Ruta - Usuario",
        minWidth: 250,
        sortable: true,
        cellRenderer: RouteUserCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const subRoute = item.subRoute;
            const user = item.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            return `${routeName} - ${userName}`;
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const subRoute = rowData.subRoute;
            const user = rowData.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            const displayValue = `${routeName} - ${userName}`;
            if (!displayValue || displayValue === "- - -") return !filterValue;
            return displayValue === filterValue;
          },
        },
      },
      // Date column
      {
        field: "trip.dateHourStart" as any,
        headerName: "Día",
        minWidth: 150,
        sortable: true,
        cellRenderer: DateCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const date = item.trip?.dateHourStart;
            if (!date) return "-";
            return new Date(date).toLocaleDateString("es-ES");
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const date = rowData.trip?.dateHourStart;
            if (!date) return !filterValue;
            const formattedDate = new Date(date).toLocaleDateString("es-ES");
            return formattedDate === filterValue;
          },
        },
      },
      // Visita Día column
      {
        field: "visitsIndicator.VisitDay" as any,
        headerName: "Visita\nDía",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) =>
          String(data?.visitsIndicator?.VisitDay ?? "-"),
        cellRenderer: NumericCellRendererComponent,
      },
      // ExtraRuta column
      {
        field: "visitsIndicator.VisitaExtraRuta" as any,
        headerName: "ExtraRuta",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) =>
          String(data?.visitsIndicator?.VisitaExtraRuta ?? "-"),
        cellRenderer: NumericCellRendererComponent,
      },
      // Efectuada column
      {
        field: "visitsIndicator.VisitaEfectuada" as any,
        headerName: "Efectuada",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) =>
          String(data?.visitsIndicator?.VisitaEfectuada ?? "-"),
        cellRenderer: NumericCellRendererComponent,
      },
      // Faltante column
      {
        field: "VisitaFaltante" as any,
        headerName: "Faltante",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) => String(data?.VisitaFaltante ?? "-"),
        cellRenderer: NumericCellRendererComponent,
      },
      // % de Visita column
      {
        field: "percent_visit" as any,
        headerName: "% de\nVisita",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) => {
          const val = data?.percent_visit;
          return val != null ? String(val.toFixed(2)) : "-";
        },
        cellRenderer: NumericCellRendererComponent,
      },
      // Visita Efectiva column
      {
        field: "visitaEfectiva" as any,
        headerName: "Visita\nEfectiva",
        minWidth: 100,
        sortable: true,
        valueFormatter: (value, data) => String(data?.visitaEfectiva ?? "-"),
        cellRenderer: NumericCellRendererComponent,
      },
      // % de Efectividad column
      {
        field: "Efectividad" as any,
        headerName: "% de\nEfectividad",
        minWidth: 120,
        sortable: true,
        valueFormatter: (value, data) => {
          const val = data?.Efectividad;
          return val != null ? String(val.toFixed(2)) : "-";
        },
        cellRenderer: NumericCellRendererComponent,
      },
      // Duración Ruta column
      {
        field: "totalRouteDurationHours" as any,
        headerName: "Duración\nRuta",
        minWidth: 120,
        sortable: true,
        valueFormatter: (value, data) => {
          const hours = data?.totalRouteDurationHours;
          if (!hours) return "-";
          const h = Math.floor(hours);
          const m = Math.round((hours - h) * 60);
          return `${h}h ${m}m`;
        },
      },
      // Tiempo Efectivo column
      {
        field: "totalVisitDurationHours" as any,
        headerName: "Tiempo\nEfectivo",
        minWidth: 120,
        sortable: true,
        valueFormatter: (value, data) => {
          const hours = data?.totalVisitDurationHours;
          if (!hours) return "-";
          const h = Math.floor(hours);
          const m = Math.round((hours - h) * 60);
          return `${h}h ${m}m`;
        },
      },
      // Duración Viaje column
      {
        field: "tripDurationHours" as any,
        headerName: "Duración\nViaje",
        minWidth: 150,
        sortable: false,
        valueFormatter: (value, data) => {
          const teoric = data?.tripDurationHoursTeoric;
          const real = data?.tripDurationHours;
          const teoricStr = teoric
            ? `${Math.floor(teoric)}h ${Math.round((teoric - Math.floor(teoric)) * 60)}m`
            : "-";
          const realStr = real
            ? `${Math.floor(real)}h ${Math.round((real - Math.floor(real)) * 60)}m`
            : "-";
          return `E: ${teoricStr}\nR: ${realStr}`;
        },
      },
    ];
  }

  private initializeGridConfig(): void {
  this.gridConfig = {
    rowIdField: "_id" as any,
    emptyState: {
      message: "No encontramos tus resultados!",
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "subRoute.code" as any, direction: "desc" }],
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    columnVisibility: {
      enabled: false, // Disabled - now in settings panel
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40, // Increased for more spacing
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      density: "comfortable",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "3px",
    },
    settingsPanel: {
      enabled: true,
      position: "right",
      enableColumnVisibility: true,
      defaultDensity: "compact",
    },
    rowExpansion: {
      enabled: true,
      multipleExpand: false,
      expandOnClick: false,
    },
  };
  }

  private fetchAllRoutes(): void {
    this.subRouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRouteList = res.data;
        this.filteredRoutes.next(this.subRouteList);

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxStateRoute();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching subroute","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterRouteMulti() {
    if (!this.subRouteList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.subRouteList;
      this.filteredRoutes.next(this.subRouteList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredRouteCache = this.subRouteList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateRoute() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  onSortChange(event: SortChangedEvent<any>): void {
    this.pageIndex = 1;
    this.sortActive = event.sortStates[0].field as string;
    this.sortDirection = event.sortStates[0].direction === 'asc' ? 'ASC' : 'DESC';
    this.findAllWithCount();
  }

  onPageChange(event: PageChangedEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onRowExpansionChanged(event: {
    data: any;
    expanded: boolean;
    expandedRows: any[];
  }): void {
    const trip = event.data;
    const tripId = trip._id?.toString() || "";

    if (!event.expanded) {
      // Clear detail data when row collapses
      this.selectedTrip = null;
      this.dataSourceDetail.data = [];
      this.expandedRowDetails.delete(tripId);
      this.cdr.detectChanges();
      return;
    }

    // Load detail data when row expands
    this.selectedTrip = trip;
    this.onFilterVisits(trip);

    // Store detail data for this row
    this.expandedRowDetails.set(tripId, trip.visits || []);

    // Force change detection
    this.cdr.detectChanges();
  }

  findAllWithCount(): void {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });


    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      customerId: this.form.get("customerId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,
    }

    this.isLoading = true;
    this.tripService
      .findAllWithCountByTrip({
        currentPage: this.pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: this.sortActive as keyof VisitAttributes,
        sortDirection: this.sortDirection,
      },
      filter
     )
      .subscribe((data) => {
        this.data = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.isLoading = false;
      });
  }

  downloadReport(visit: VisitAttributes) {

    this.tripService
      .exportVisitXLSX({
        search: this.searchQuery,
        sort: this.sortActive as keyof VisitAttributes,
        sortDirection: this.sortDirection,
        startDate: new Date(this.filter.dateini).toISOString(),
        endDate: new Date(
          new Date(this.filter.dateend).setHours(23, 59, 59, 999)
        ).toISOString(),
      })
      .subscribe((data: any) => {

        // Obtener la URL del archivo desde la respuesta
        const { fileUrl } = data.json(); //TODO todo

        // Descargar el archivo usando la URL proporcionada
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Reporte.xlsx"; // Usa el nombre del archivo proporcionado o lo puedes poner fijo
        link.click();
      });
  }

  downloadReportExcel(visit: any) {
    if (!visit.visits || !Array.isArray(visit.visits) || visit.visits.length === 0) {
      this.snackBar.open('No cuenta con detalle', 'Cerrar', { duration: 3000 });
      return;
    }

    if (!this.visitDetailReportExport.canStartTask()) return;

    this.visitDetailReportExport.export(
      ExportFileFormat.Excel,
      visit.visits
    );
  }

  openImageCarousel(images: any[]) {
    const imageLinks = images.map((image) => image.image.link);
    const dialogRef = this.dialog.open(ImageCarouselComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: { images: imageLinks },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  // onFilter(){
  //   const sortField = this.getSortField();
  //   const sortDirection: "ASC" | "DESC" = this.sortDirection === "asc" ? "ASC" : "DESC";

  //   let options = {
  //     currentPage: this.pageIndex,
  //     limitPerPage: this.pageSize,
  //     search: this.search,
  //     sort: sortField,
  //     sortDirection: sortDirection
  //   }

  //   let dataFilter = {
  //     //type: DocumentTypeEnum.PEDIDO, //Pedidos,
  //     startDate: new Date(this.filter.dateini).toISOString(),
  //     endDate: new Date(new Date(this.filter.dateend).setHours(23, 59, 59, 999)).toISOString(),
  //     /*documentClass: this.selectedDocumentClass,
  //     seller: this.selectedSeller.toString(),
  //     withTravel: this.selectedWithTravel,
  //     statusERP: this.selectedStatusERP,*/
  //   }
  //   this.tripService.findAllWithCount(options, dataFilter).subscribe({
  //     next: (res: IPaginationResult<TripAttributesExt>) => {
  //       this.dataSource.data = res?.data?.[0]?.data ?? [];
  //       this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
  //     },
  //     error: (err) => {
  //     },
  //   })
  // }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }



  private getSortField(): string {
    return "dateHourEndTeoric";
  }

  // toggleDetails is now handled by SmartGrid rowExpansion via onRowExpansionChanged

  onClearFilter() {
    this.form.reset({
      start: new Date(),
      end: new Date(),  
    });
    this.findAllWithCount();
  }

  // applyFilter(filterValue: string) {
  //   this.pageIndex = 1
  //   this.search = filterValue
  //   // this.onFilter()
  // }

  // changeSort is now handled by SmartGrid via onSortChange

  clearFilters(): void {
    this.routeMultiCtrl.setValue([]);
    this.searchQuery = "";
    this.findAllWithCount();
  }


  onFilterVisits(element: any) {
    const tripId = element._id?.toString() || "";

    this.dataSourceDetail.data = [];
    this.dataSourceDetail.data = element.visits;

    this.dataSourceDetail.data = element.visits.map((detail, index) => {
      const appCoords = detail?.geoPoint ?? "-";
      const aveCoords = detail?.address?.[0]?.geolocationPoint ?? "-";
      let distance: number | null = null;
      let distanceMeters: number | null = null;
      if (appCoords !== "-" && aveCoords !== "-") {
        distanceMeters  = this.distanceCalculator.calculateDistanceMeters(
          appCoords as [number, number],
          aveCoords as [number, number]
        );
      }
      return {
        ...detail,
        distance: this.formatDistance(distanceMeters)

      };
  });

  // Store detail data in expandedRowDetails Map
  this.expandedRowDetails.set(tripId, this.dataSourceDetail.data);



    //   const sortField = this.getSortField();
    //   const sortDirection: "ASC" | "DESC" = this.sortDirection === "asc" ? "ASC" : "DESC";

    //   let options = {
    //     currentPage: this.pageIndex,
    //     limitPerPage: this.pageSize,
    //     search: this.search,
    //     sort: null,
    //     sortDirection: sortDirection
    //   }

    //   let dataFilter = {
    //     tripId: element.id,
    //   }
    //   this.tripService.findAllVisitWithCount(options, dataFilter).subscribe({
    //     next: (res: IPaginationResult<VisitAttributes>) => {
    //       this.dataSourceDetail.data = res?.data?.[0]?.data ?? [];
    //       this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
    //     },
    //     error: (err) => {
    //     },
    //   })
  }

  private formatDistance(meters: number | null): string | null {
  if (meters === null) return null;
  if (meters >= 1000) {
    return `${(meters / 1000).toFixed(2)} km`;
  } else if (meters >= 10) {
    return `${meters.toFixed(2)} m`;
  } else {
    return `${meters.toFixed(2)} m`;
  }
}

    
  openModal(element, type): void {
    if(this.isNew){
      const data: MapModalInputData = {
        type: type == 'H' ? MapModalTypeEnum.VISIT_ROUTE : MapModalTypeEnum.SIMPLE_TWO,
        tripId: null,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: 'drawer',
          captions: { title: 'Ubicación' }
        }
      }

      this.openMap(data)
    }else{
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: { element, type: type },
        disableClose: true,
      });
    }
  }
  
  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }

  onExportButtonPressed() {
    if (!this.visitReportExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: VISIT_REPORT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.visitReportExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  goToTravel(element: VisitAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(['monitor', 'principal-screen'], { queryParams });
      const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
